import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { UiHelpersService } from '../../services';

@Component({
  selector: 'phoenix-upload-image',
  templateUrl: './upload-image.component.html',
  standalone: false,
})
export class UploadImageComponent {
  _attributionMedia: File[] = [];
  uiHelper = inject(UiHelpersService);

  @Input() aria = '';
  @Input() control = new FormControl<File | File[] | null>(null);
  @Input() controlGroup: FormGroup = new FormGroup({});
  @Input() maxImages: number | undefined = undefined; // If undefined, no limit on the number of images
  @Input() showMedia = true;
  @Output() imageList = new EventEmitter<File[]>();

  get attributionMedia(): File[] {
    return this._attributionMedia;
  }

  onFileSelected(event: any) {
    if (!event.target.files || event.target.files.length === 0) {
      return;
    }
    if (
      this.maxImages !== undefined &&
      this._attributionMedia.length >= this.maxImages
    ) {
      this.uiHelper.errorSnackbar(
        `You can only upload ${this.maxImages} images.`
      );
      return;
    }
    const invalidFiles = Array.from(event.target.files as File[]).filter(
      (file: File) => file.type !== 'image/png' && file.type !== 'image/jpeg'
    );

    if (invalidFiles.length > 0) {
      this.uiHelper.errorSnackbar('Only PNG and JPG images are allowed.');
      return;
    }

    const filesArray = Array.from(event.target.files);
    this._attributionMedia.push(...(filesArray as File[]));

    if (this._attributionMedia.length > 0) {
      this.control.setValue(this._attributionMedia);
      this.controlGroup.markAsDirty();
    }
    this.imageList.emit(this._attributionMedia);
  }

  truncateFilename(filename: string, maxLength: number): string {
    const ext = filename.slice(((filename.lastIndexOf('.') - 1) >>> 0) + 2);
    const base = filename.substring(0, filename.length - ext.length - 1);

    if (base.length <= maxLength) {
      return filename;
    }

    return base.substring(0, maxLength) + '...' + '.' + ext;
  }

  formatFileSize(sizeInBytes: number) {
    const units = ['B', 'KB', 'MB', 'GB', 'TB'];
    let index = 0;

    while (sizeInBytes >= 1024 && index < units.length - 1) {
      sizeInBytes /= 1024;
      index++;
    }

    return `${sizeInBytes.toFixed(2)} ${units[index]}`;
  }

  removeFile(index: number) {
    this._attributionMedia.splice(index, 1);

    if (this._attributionMedia.length > 0) {
      this.control.setValue(this._attributionMedia);
    } else {
      this.control.setValue([]);
    }
    this.imageList.emit(this._attributionMedia);

    this.controlGroup.markAsDirty();
  }
}
